<div class="vincent_subscribe" style="margin: 100px 0px;">
    <div class="vincent_container">
        <div class="row align-center">
            <div class="col col-6">
                <a class="vincent_button" routerLink="/general-reviews" style="text-align: right;"> 
                {{"show_comments" | translate}}
                </a>
            </div>
        </div>
    </div>
</div>